import * as Yup from 'yup';

export const stripeSettingsSchema = Yup.object().shape({
    // Blank = keep the existing stored secret key (secrets are no longer returned by the API).
    secretKey: Yup.string(),
})


